export default {
  login: '/login',
};
